import React, {FC} from 'react';

/** 交付政策中文正文（i18n：壳组件按语言选择 zh/en 内容组件，类名复用 TermsOfUse__* BEM） */
const ZhContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">生效时间: 2026年8月28日</p>
      <p className="v3-doc-meta">上次更新时间: 2026年8月28日</p>
      <p>感谢您选择象寄服务。</p>
      <p>
        本《象寄服务交付政策》（以下简称“本政策”）用于说明象寄向用户提供软件即服务（SaaS）、AI视觉内容处理及其他数字化服务的交付方式、交付时间、服务开通及相关事项。
      </p>
      <p>
        <strong>象寄提供的服务均属于数字化服务，一般不涉及实物商品的生产、仓储或物流配送。</strong>
      </p>
      <section>
        <h2>一、数字化服务交付</h2>
        <h3>服务性质</h3>
        <p>象寄主要通过互联网向用户提供数字化产品及服务，包括但不限于：</p>
        <ul>
          <li>图片翻译；</li>
          <li>图片编辑及修图；</li>
          <li>AI图片生成；</li>
          <li>商品场景图生成；</li>
          <li>商品模特图生成；</li>
          <li>商品主图、副图生成；</li>
          <li>商品详情套图生成；</li>
          <li>商品详情页及A+内容生成；</li>
          <li>视频及视觉内容处理；</li>
          <li>文件及PSD处理；</li>
          <li>API及其他技术服务；</li>
          <li>订阅服务及相关会员权益；</li>
          <li>点数、额度及其他数字化服务权益。</li>
        </ul>
        <p>
          <strong>上述服务均通过象寄网站、客户端、浏览器插件、API或其他线上方式进行交付，不提供实物商品配送。</strong>
        </p>
      </section>
      <section>
        <h2>二、服务交付方式</h2>
        <h3>账号交付</h3>
        <p>对于需要注册账号使用的服务，您完成注册或登录并成功开通相应服务后，即可通过您的象寄账号访问相关服务。</p>
        <h3>订阅服务交付</h3>
        <p>对于订阅服务，您完成支付且订单确认成功后，相关订阅权益通常会自动绑定至您的象寄账号。</p>
        <p>
          <strong>您无需等待实物发货或物流配送，订阅服务通常在订单完成后即可使用。</strong>
        </p>
        <p>具体订阅周期、权益范围、使用额度及有效期以购买页面及相关订阅协议为准。</p>
        <h3>点数及额度交付</h3>
        <p>
          对于象寄提供的点数、Credits、使用额度或其他数字化权益，支付成功并完成订单确认后，相关权益通常会自动发放至您的象寄账号。
        </p>
        <p>您可以在账户余额、订单记录或相关服务页面查看相应权益。</p>
        <h3>单次服务交付</h3>
        <p>
          对于图片翻译、图片编辑、AI图片生成、详情套图生成等按次或按量计费的服务，您提交任务并完成相应支付后，象寄将按照产品页面显示的服务流程处理您的任务。
        </p>
        <p>
          <strong>
            相关生成结果、处理结果或其他数字化成果通常通过象寄产品界面直接交付，您可以在任务完成后进行查看、下载或进一步编辑。
          </strong>
        </p>
        <h3>API服务</h3>
        <p>
          对于API服务，象寄将在您完成账号注册、API服务开通及必要配置后，根据相关API服务协议或技术文档向您提供接口访问权限。
        </p>
        <p>API服务的具体交付方式、调用限制、额度、计费方式及技术要求，以API服务页面及相关协议为准。</p>
      </section>
      <section>
        <h2>三、交付时间</h2>
        <h3>自动交付</h3>
        <p>除产品页面另有说明外，象寄提供的标准数字化服务通常采用自动化方式交付。</p>
        <p>
          <strong>在支付成功、订单确认及必要的安全验证完成后，相关服务通常会立即或在合理时间内开通。</strong>
        </p>
        <h3>AI生成及处理服务</h3>
        <p>AI图片生成、图片翻译、图片编辑、视频处理及其他计算密集型服务需要经过系统处理。</p>
        <p>
          由于任务复杂程度、文件大小、服务器负载、AI模型处理速度及其他技术因素不同，
          <strong>具体处理时间可能存在差异。</strong>
        </p>
        <p>产品页面显示的预计处理时间仅供参考，不构成对具体完成时间的绝对承诺。</p>
        <h3>人工或特殊服务</h3>
        <p>
          如某项服务需要人工审核、人工处理、特殊配置或其他额外操作，具体交付时间以服务页面、订单页面或双方另行约定为准。
        </p>
      </section>
      <section>
        <h2>四、订单及支付确认</h2>
        <h3>支付成功</h3>
        <p>您完成订单支付后，支付机构可能需要一定时间对交易进行确认。</p>
        <p>
          <strong>只有在象寄系统确认订单支付成功后，相关数字化服务权益才会按照本政策进行交付。</strong>
        </p>
        <h3>支付异常</h3>
        <p>如果您已经完成付款，但象寄账户未显示订单成功、服务权益未到账或出现其他异常，请及时联系象寄客服。</p>
        <p>象寄将在核实订单及支付状态后，根据实际情况进行处理。</p>
        <h3>第三方支付</h3>
        <p>如果您通过第三方支付机构完成支付，支付机构可能存在交易审核、支付延迟、退款处理或其他技术原因。</p>
        <p>因第三方支付机构自身原因导致的支付延迟或异常，象寄将在合理范围内协助您处理。</p>
      </section>
      <section>
        <h2>五、账号及服务访问</h2>
        <h3>账号责任</h3>
        <p>
          <strong>您应确保注册及购买服务时使用的象寄账号信息准确、有效，并妥善保管账号及登录凭证。</strong>
        </p>
        <p>服务权益通常与您购买时使用的象寄账号绑定。</p>
        <h3>账号错误</h3>
        <p>如果您因自身原因使用错误账号购买服务，导致相关服务权益被绑定至其他账号，您应及时联系客服进行核实。</p>
        <p>
          <strong>在法律允许的范围内，因您自身操作错误导致的服务权益异常，象寄不承担由此产生的损失。</strong>
        </p>
        <h3>账号共享</h3>
        <p>
          除象寄明确支持的企业版、多用户协作或其他团队功能外，您不得通过出租、出借、转让、共享账号等方式向他人提供服务。
        </p>
      </section>
      <section>
        <h2>六、交付异常</h2>
        <p>如果您遇到以下情况，请及时联系象寄客服：</p>
        <ul>
          <li>支付成功但服务未开通；</li>
          <li>点数或额度未到账；</li>
          <li>订阅权益未生效；</li>
          <li>AI任务长时间未完成；</li>
          <li>已完成任务但无法正常查看或下载；</li>
          <li>API服务未正常开通；</li>
          <li>其他与服务交付有关的异常。</li>
        </ul>
        <p>象寄将在核实订单、账户及系统记录后，在合理范围内采取补发、重新处理、恢复服务或其他合理措施。</p>
        <h3>系统原因</h3>
        <p>
          <strong>
            如因象寄系统故障导致您实际购买的服务权益未正确交付，在相关订单及支付记录能够得到有效核实的情况下，象寄将根据实际情况补发相关权益或采取其他合理补救措施。
          </strong>
        </p>
        <h3>用户原因</h3>
        <p>因以下原因造成的交付异常，象寄将在法律允许的范围内不承担相关责任：</p>
        <ul>
          <li>用户提供错误的账号信息；</li>
          <li>用户自行修改或删除相关账户信息；</li>
          <li>用户账号被封禁或限制使用；</li>
          <li>用户设备、网络或软件环境异常；</li>
          <li>用户未按照服务要求完成必要配置；</li>
          <li>其他因用户自身原因造成的服务无法正常使用。</li>
        </ul>
      </section>
      <section>
        <h2>七、服务不可用及第三方服务</h2>
        <p>象寄部分产品和功能依赖云计算服务、AI模型、翻译引擎、网络服务商、支付机构及其他第三方技术服务。</p>
        <p>
          <strong>
            因第三方服务发生故障、维护、升级、容量限制、接口调整或其他超出象寄合理控制范围的原因，可能导致服务延迟、中断或暂时无法使用。
          </strong>
        </p>
        <p>在此情况下，象寄将根据实际情况采取合理措施，包括但不限于：</p>
        <ul>
          <li>恢复相关服务；</li>
          <li>更换技术服务；</li>
          <li>延迟处理任务；</li>
          <li>重新处理相关任务；</li>
          <li>补发相应服务权益；</li>
          <li>其他合理补救措施。</li>
        </ul>
      </section>
      <section>
        <h2>八、服务下载及数据保存</h2>
        <h3>下载</h3>
        <p>
          对于支持下载的AI生成结果、翻译结果、编辑结果及其他数字化内容，您可以按照象寄产品页面提供的方式进行下载或导出。
        </p>
        <h3>用户备份责任</h3>
        <p>
          <strong>您应自行对需要长期保存的生成结果、处理文件、项目数据及其他重要内容进行及时备份。</strong>
        </p>
        <p>
          除法律法规另有规定或双方另有约定外，象寄不承诺对已经终止服务、删除账号或超过平台规定保存期限的数据进行永久保存。
        </p>
        <h3>服务终止后的数据</h3>
        <p>
          如您的账号被注销、服务终止或相关项目超过平台规定的保存期限，相关数据可能被删除或按照象寄隐私政策进行处理。
        </p>
      </section>
      <section>
        <h2>九、服务交付完成的认定</h2>
        <p>在以下任一情形发生后，原则上视为相关数字化服务已经完成交付：</p>
        <ol>
          <li>订阅权益已经成功绑定至您的象寄账号；</li>
          <li>点数、Credits或其他数字权益已经成功到账；</li>
          <li>API访问权限已经成功开通；</li>
          <li>AI生成或处理任务已经完成并可以正常查看或下载；</li>
          <li>相关服务已经按照产品页面约定向您的账号提供；</li>
          <li>其他双方约定的交付条件已经完成。</li>
        </ol>
        <p>
          <strong>
            对于已经完成交付或已经实际使用的数字化服务，其退款及相关处理按照《象寄退款政策》《象寄订阅服务购买协议》及其他适用规则执行。
          </strong>
        </p>
      </section>
      <section>
        <h2>十、政策变更</h2>
        <p>
          <strong>象寄有权根据法律法规变化、业务发展、产品调整及技术升级，对本交付政策进行修改或补充。</strong>
        </p>
        <p>如本政策发生重大变化，象寄将通过网站公告、产品页面、弹窗、站内通知或其他合理方式进行提示。</p>
        <p>修改后的政策自公布或规定的生效日期起生效。</p>
      </section>
      <section>
        <h2>十一、联系我们</h2>
        <p>如果您对服务交付、订单状态、服务开通或其他相关事项有任何疑问，可以通过以下方式联系我们：</p>
        <ul>
          <li>
            <strong>官方网站：</strong>
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
          <li>
            <strong>在线客服：</strong>象寄产品内在线客服
          </li>
          <li>
            <strong>客服邮箱：</strong>
            <a href="mailto:bussiness@tosoiot.com">bussiness@tosoiot.com</a>
          </li>
          <li>
            <strong>联系电话：</strong>+86 176 6407 5341
          </li>
        </ul>
        <p>我们将在收到您的咨询后，在合理期限内进行处理。</p>
        <p>
          <strong>
            本政策未尽事宜，以《象寄用户服务条款》《象寄隐私政策》《象寄订阅服务购买协议》及相关专项服务规则为准。
          </strong>
        </p>
      </section>
    </>
  );
};

export default ZhContent;
